import { useTranslation } from "react-i18next"

import { SegmentedControl } from "@/components/segmented-control"
import {
  type CreatorAnalyticsWindow,
  WINDOW_VALUES,
} from "@/types/creator-analytics"

export interface CreatorAnalyticsWindowToggleProps {
  value: CreatorAnalyticsWindow
  onChange: (next: CreatorAnalyticsWindow) => void
}

/**
 * OKS-64 — Window filter for the per-creator analytics page.
 * 3 options (30d / 90d / all-time), URL-stateful via the parent
 * page's `onChange` handler (TRD K15 / K16).
 *
 * Per UX Spec §1: right-aligned at desktop, stacks below H1 on
 * mobile (parent owns the layout flex; this component is content-
 * only).
 */
export function CreatorAnalyticsWindowToggle({
  value,
  onChange,
}: CreatorAnalyticsWindowToggleProps) {
  const { t } = useTranslation()

  return (
    <SegmentedControl
      value={value}
      // Radio-group only emits valid option values and never fires for
      // the already-active option — no guard needed.
      onValueChange={onChange}
      aria-label={t("crew.analytics.window.label")}
      data-testid="creator-analytics-window-toggle"
      options={WINDOW_VALUES.map((window) => ({
        value: window,
        label: t(`crew.analytics.window.${window}`),
        "data-testid": `creator-analytics-window-toggle-${window}`,
      }))}
    />
  )
}

export default CreatorAnalyticsWindowToggle
